import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'
import { loadSetupTradeLog } from '../lib/loadSetupTradeLog'

const empty = { trades: [], groups: [], unresolved: [], nicknameMap: {} }

export function useSetupTradeLog() {
  const { user } = useAuth()
  const userId = user?.id
  const [revision, setRevision] = useState(0)
  const [state, setState] = useState({ ...empty, loading: true })
  useEffect(() => {
    const controller = new AbortController()
    let active = true
    setState({ ...empty, userId, loading: !!userId, error: userId ? null : 'Sign in to load trade history.' })
    if (!userId) return () => { active = false; controller.abort() }
    const timer = setTimeout(() => controller.abort(), 30000)
    loadSetupTradeLog(supabase, userId, controller.signal)
      .then(result => { if (active) setState({ ...result, userId, loading: false, error: null }) })
      .catch(error => { if (active) setState({ ...empty, userId, loading: false,
        error: controller.signal.aborted ? 'Trade history timed out. Retry to refresh all records.' : error.message }) })
      .finally(() => clearTimeout(timer))
    return () => { active = false; controller.abort(); clearTimeout(timer) }
  }, [userId, revision])
  return { ...(state.userId === userId ? state : { ...empty, loading: true }),
    reload: () => setRevision(value => value + 1) }
}
